module.exports = "https://bin.bnbstatic.com/_next/static/images/ThieuHung-e7076456d4de50a2082c93cba3c04b31.jpg";